// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f7fa;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Navbar styles */
.navbar {
  background-color: #2c3e50;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.navbar a {
  color: white;
  text-decoration: none;
  margin-left: 20px;
}

.navbar-brand a {
  font-size: 1.5rem;
  font-weight: bold;
  margin-left: 0;
}

.logout-button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  margin-left: 20px;
}

/* Form styles */
.login-container,
.register-container {
  max-width: 500px;
  margin: 40px auto;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  margin-bottom: 20px;
  color: #2c3e50;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
}

input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 3px;
}

button:hover {
  background-color: #2980b9;
}

.error {
  color: #e74c3c;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #ffeaea;
  border-radius: 4px;
}

/* Dashboard styles */
.dashboard-container {
  padding: 20px;
}

.activities-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.activity-card {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.activity-card.completed {
  border-left: 5px solid #27ae60;
}

.activity-card h3 {
  margin-bottom: 10px;
  color: #2c3e50;
}

.activity-content {
  margin: 10px 0;
  color: #666;
}

.complete-button {
  background-color: #27ae60;
  margin-top: 15px;
}

.complete-button:hover {
  background-color: #219653;
}

.completed-badge {
  display: inline-block;
  background-color: #27ae60;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  margin-top: 15px;
  font-size: 14px;
}
.dashboard-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.activities-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.activities-table th,
.activities-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.activities-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.activities-table tr:hover {
  background-color: #f9f9f9;
}

.activity-name {
  font-weight: 500;
  color: #2c3e50;
}

.activity-type {
  color: #7f8c8d;
}

.activity-content {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-button {
  display: inline-block;
  padding: 8px 12px;
  background-color: #3498db;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s;
  margin: 2px;

}

.view-button:hover {
  background-color: #2980b9;
}

.no-activities {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
  text-align: center;
  color: #6c757d;
}

.table-responsive {
  overflow-x: auto;
}

.user-management-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #4a90e2;
  outline: none;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  border-left: 4px solid #c62828;
}

.loading-indicator {
  text-align: center;
  padding: 30px;
  color: #666;
  font-size: 16px;
}

.table-responsive {
  overflow-x: auto;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.users-table th {
  background-color: #f5f7fa;
  color: #333;
  font-weight: 600;
  text-align: left;
  padding: 14px 16px;
  border-bottom: 2px solid #e3e8ee;
}

.users-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e3e8ee;
  text-align: center;
}

.user-row:hover {
  background-color: #f9fafc;
}

.user-name {
  font-weight: 500;
  color: #2c3e50;
}

.user-email {
  color: #3498db;
}

.user-actions {
  white-space: nowrap;
}

.view-measurements-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.view-measurements-button:hover {
  background-color: #3a7bc8;
}

.no-results-row td {
  text-align: center;
  padding: 30px;
  color: #666;
}

.user-count {
  text-align: right;
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.actions-container {
  margin-top: 20px;
}

.back-button {
  background-color: #f5f7fa;
  color: #333;
  border: 1px solid #ddd;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.back-button:hover {
  background-color: #e9ecef;
}
/* src/pages/QuestionnaireList.css */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.subtitle {
  color: #6c757d;
  margin-top: 5px;
}

.create-button {
  background-color: #007bff;
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;
}

.create-button:hover {
  background-color: #0069d9;
}

.search-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
}

.search-box {
  flex: 1 1;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.results-count {
  color: #6c757d;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.loading-container {
  text-align: center;
  padding: 40px 0;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 40px 0;
}

.questionnaires-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.questionnaires-table th,
.questionnaires-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.questionnaires-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

.questionnaires-table tr:hover {
  background-color: #f8f9fa;
}

.title-cell {
  font-weight: bold;
}

.no-description {
  color: #6c757d;
  font-style: italic;
}

.badge {
  background-color: #17a2b8;
  color: white;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 0.85em;
}

.action-buttons {
  display: flex;
  gap: 5px;
}

.view-button,
.edit-button,
.delete-button {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-button {
  background-color: #6c757d;
  color: white;
}

.edit-button {
  background-color: #17a2b8;
  color: white;
}

.delete-button {
  background-color: #dc3545;
  color: white;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination-button {
  padding: 8px 12px;
  margin: 0 5px;
  border: 1px solid #dee2e6;
  background-color: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 5px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  gap: 10px;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .create-button {
    margin-top: 10px;
  }
  
  .search-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-box {
    max-width: 100%;
    margin-bottom: 10px;
  }
  
  .questionnaires-table {
    display: block;
    overflow-x: auto;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}
/* EditQuestionnaire.css */
.questionnaire-editor {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.editor-header {
  margin-bottom: 30px;
}

.editor-header h1 {
  margin: 15px 0;
  color: #333;
  font-weight: 600;
}

.back-button {
  background: none;
  border: none;
  color: #0066cc;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s;
}

.back-button:hover {
  color: #004499;
  text-decoration: underline;
}

.error-message, .success-message {
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 16px;
}

.error-message {
  background-color: #fff3f3;
  color: #d32f2f;
  border-left: 4px solid #d32f2f;
}

.validation-errors ul {
  margin-top: 10px;
  margin-bottom: 0;
  padding-left: 20px;
}

.validation-errors li {
  margin-bottom: 5px;
}

.success-message {
  background-color: #f0fff0;
  color: #2e7d32;
  border-left: 4px solid #2e7d32;
  display: flex;
  align-items: center;
}

.success-icon {
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #0066cc;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.editor-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
  overflow: hidden;
}

.section-header {
  background-color: #f7f9fc;
  padding: 15px 20px;
  border-bottom: 1px solid #e1e4e8;
}

.section-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.questions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

input[type="text"],
textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

input[type="text"]:focus,
textarea:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  outline: none;
}

.input-error {
  border-color: #d32f2f !important;
}

.error-text {
  color: #d32f2f;
  font-size: 14px;
  margin-top: 5px;
}

.add-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-button:hover {
  background-color: #004499;
}

.empty-questions {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.empty-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 15px;
  display: inline-block;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
  background-color: #f5f5f5;
}

.questions-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.question-card {
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
}

.question-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.question-card.active {
  border-color: #0066cc;
  box-shadow: 0 2px 12px rgba(0, 102, 204, 0.2);
}

.question-header {
  padding: 15px;
  background-color: #f7f9fc;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
}

.question-card.active .question-header {
  background-color: #e6f0ff;
}

.question-header:hover {
  background-color: #e6f0ff;
}

.question-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #0066cc;
  color: white;
  border-radius: 50%;
  font-weight: bold;
}

.question-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.question-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.options-count {
  font-size: 14px;
  color: #666;
}

.expand-icon {
  color: #0066cc;
  font-size: 12px;
}

.question-body {
  padding: 20px;
  border-top: 1px solid #e1e4e8;
}

.options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.add-option-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-option-button:hover {
  background-color: #e0e0e0;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  border: 1px solid #e1e4e8;
  border-radius: 4px;
  padding: 10px;
  transition: border-color 0.2s;
}

.option-item:hover {
  border-color: #0066cc;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.radio-label {
  font-size: 12px;
  color: #2e7d32;
  font-weight: bold;
}

.option-input-container {
  flex: 1 1;
  display: flex;
  gap: 10px;
}

.remove-option-button {
  background: none;
  border: none;
  color: #d32f2f;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
  transition: color 0.2s;
}

.remove-option-button:hover {
  color: #b71c1c;
}

.remove-option-button:disabled {
  color: #ccc;
  cursor: not-allowed;
}

.option-error {
  margin-left: 30px;
}

.question-footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.remove-question-button {
  background: none;
  border: 1px solid #d32f2f;
  color: #d32f2f;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.remove-question-button:hover {
  background-color: #d32f2f;
  color: white;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.save-button {
  background-color: #2e7d32;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.save-button:hover {
  background-color: #1b5e20;
}

.save-button:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@media (max-width: 768px) {
  .question-title h3 {
    max-width: 200px;
  }
  
  .option-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .radio-container {
    margin-bottom: 10px;
  }
  
  .form-actions {
    flex-direction: column-reverse;
    gap: 10px;
  }
  
  .cancel-button, .save-button {
    width: 100%;
    justify-content: center;
  }
}

/* src/pages/admin/CreateQuestionnaire.css */
.questionnaire-creator {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.creator-header {
  margin-bottom: 30px;
}

.creator-header h1 {
  margin: 15px 0;
  color: #333;
  font-weight: 600;
}

.back-button {
  background: none;
  border: none;
  color: #0066cc;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s;
}

.back-button:hover {
  color: #004499;
  text-decoration: underline;
}

.error-message, .success-message {
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 16px;
}

.error-message {
  background-color: #fff3f3;
  color: #d32f2f;
  border-left: 4px solid #d32f2f;
}

.success-message {
  background-color: #f0fff0;
  color: #2e7d32;
  border-left: 4px solid #2e7d32;
  display: flex;
  align-items: center;
}

.success-icon {
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold;
}

.creator-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
  overflow: hidden;
}

.section-header {
  background-color: #f7f9fc;
  padding: 15px 20px;
  border-bottom: 1px solid #e1e4e8;
}

.section-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.questions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

input[type="text"],
textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

input[type="text"]:focus,
textarea:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  outline: none;
}

.add-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-button:hover {
  background-color: #004499;
}

.empty-questions {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.empty-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 15px;
  display: inline-block;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
  background-color: #f5f5f5;
}

.questions-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.question-card {
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
}

.question-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.question-card.active {
  border-color: #0066cc;
  box-shadow: 0 2px 12px rgba(0, 102, 204, 0.2);
}

.question-header {
  padding: 15px;
  background-color: #f7f9fc;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
}

.question-card.active .question-header {
  background-color: #e6f0ff;
}

.question-header:hover {
  background-color: #e6f0ff;
}

.question-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #0066cc;
  color: white;
  border-radius: 50%;
  font-weight: bold;
}

.question-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.question-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.options-count {
  font-size: 14px;
  color: #666;
}

.expand-icon {
  color: #0066cc;
  font-size: 12px;
}

.question-body {
  padding: 20px;
  border-top: 1px solid #e1e4e8;
}

.options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.add-option-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-option-button:hover {
  background-color: #e0e0e0;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-item {
  border: 1px solid #e1e4e8;
  border-radius: 4px;
  padding: 10px;
  transition: border-color 0.2s;
}

.option-item:hover {
  border-color: #0066cc;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.radio-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.radio-label {
  font-size: 12px;
  color: #2e7d32;
  font-weight: bold;
}

.option-input-container {
  flex: 1 1;
  display: flex;
  gap: 10px;
}

.remove-option-button {
  background: none;
  border: none;
  color: #d32f2f;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
  transition: color 0.2s;
}

.remove-option-button:hover {
  color: #b71c1c;
}

.remove-option-button:disabled {
  color: #ccc;
  cursor: not-allowed;
}

.question-footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.remove-question-button {
  background: none;
  border: 1px solid #d32f2f;
  color: #d32f2f;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.remove-question-button:hover {
  background-color: #d32f2f;
  color: white;
}

.remove-question-button:disabled {
  border-color: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.create-button {
  background-color: #2e7d32;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.create-button:hover {
  background-color: #1b5e20;
}

.create-button:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .question-title h3 {
    max-width: 200px;
  }
  
  .option-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .radio-container {
    margin-bottom: 10px;
  }
  
  .form-actions {
    flex-direction: column-reverse;
    gap: 10px;
  }
  
  .cancel-button, .create-button {
    width: 100%;
    justify-content: center;
  }
}
/* src/pages/Dashboard.css */
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* Header Styles */
.dashboard-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.dashboard-header h1 {
  margin: 0;
  color: #333;
  font-size: 28px;
}

.admin-badge {
  background-color: #4caf50;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  margin-left: 15px;
  font-weight: 500;
}

/* Navigation Section */
.dashboard-navigation {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.nav-section h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 20px;
}

.nav-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.nav-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  text-align: center;
}

.nav-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.nav-icon {
  font-size: 32px;
  margin-bottom: 15px;
}

.nav-card h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
}

.nav-card p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

/* Activities Section */
.activities-section {
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.view-all-link {
  color: #0066cc;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.view-all-link:hover {
  color: #004499;
  text-decoration: underline;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #0066cc;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  background-color: #fff3f3;
  color: #d32f2f;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  border-left: 4px solid #d32f2f;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.empty-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 15px;
}

.empty-state h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.empty-state p {
  margin: 0;
  color: #666;
}

.activities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.activity-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: transform 0.2s;
  border-left: 4px solid #0066cc;
}

.activity-card:hover {
  transform: translateY(-3px);
}

.activity-card.completed {
  border-left-color: #4caf50;
  background-color: #f1f8e9;
}

.activity-status {
  position: absolute;
  top: 15px;
  right: 15px;
}

.status-badge {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.status-badge.pending {
  background-color: #fff8e1;
  color: #f57f17;
}

.status-badge.completed {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.activity-card h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
  padding-right: 70px; /* Make room for the status badge */
}

.activity-card p {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
}

.activity-footer {
  display: flex;
  justify-content: flex-end;
}

.complete-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.complete-button:hover {
  background-color: #004499;
}

/* Admin Stats Section */
.admin-stats-section {
  margin-top: 30px;
}

.admin-stats-section h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

.stat-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  display: flex;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 32px;
  margin-right: 20px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.users-icon {
  background-color: #e3f2fd;
  color: #1976d2;
}

.activities-icon {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.questionnaires-icon {
  background-color: #fff8e1;
  color: #f57f17;
}

.health-icon {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.stat-content {
  flex: 1 1;
}

.stat-content h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #666;
}

.stat-link {
  color: #0066cc;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.stat-link:hover {
  color: #004499;
  text-decoration: underline;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .nav-cards, .activities-grid, .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .admin-badge {
    margin-left: 0;
    margin-top: 10px;
  }
}
/* src/pages/CreateActivity.css */
.create-activity-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.create-activity-header {
  margin-bottom: 30px;
}

.create-activity-header h1 {
  margin: 15px 0;
  color: #333;
  font-size: 28px;
  font-weight: 600;
}

.back-button {
  background: none;
  border: none;
  color: #0066cc;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s;
}

.back-button:hover {
  color: #004499;
  text-decoration: underline;
}

.alert {
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
}

.error-alert {
  background-color: #fff3f3;
  color: #d32f2f;
  border-left: 4px solid #d32f2f;
}

.success-alert {
  background-color: #f0fff0;
  color: #2e7d32;
  border-left: 4px solid #2e7d32;
}

.alert-icon {
  font-size: 20px;
  margin-right: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.error-alert .alert-icon {
  background-color: #ffebee;
  color: #d32f2f;
}

.success-alert .alert-icon {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.alert-content {
  flex: 1 1;
}

.activity-form-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

.form-group {
  margin-bottom: 25px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  outline: none;
}

select.form-control {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 16px;
  padding-right: 40px;
}

textarea.form-control {
  min-height: 150px;
  resize: vertical;
}

.form-hint {
  margin-top: 6px;
  font-size: 14px;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.submit-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.submit-button:hover {
  background-color: #004499;
}

.submit-button:disabled {
  background-color: #99ccff;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .activity-form-card {
    padding: 20px;
  }
  
  .form-actions {
    flex-direction: column-reverse;
  }
  
  .cancel-button, .submit-button {
    width: 100%;
    justify-content: center;
  }
}

/* src/pages/ActivityForm.css */
.activity-form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.activity-form-header {
  margin-bottom: 30px;
}

.activity-form-header h1 {
  margin: 15px 0;
  color: #333;
  font-size: 28px;
  font-weight: 600;
}

.back-button {
  background: none;
  border: none;
  color: #0066cc;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s;
}

.back-button:hover {
  color: #004499;
  text-decoration: underline;
}

.alert {
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
}

.error-alert {
  background-color: #fff3f3;
  color: #d32f2f;
  border-left: 4px solid #d32f2f;
}

.success-alert {
  background-color: #f0fff0;
  color: #2e7d32;
  border-left: 4px solid #2e7d32;
}

.alert-icon {
  font-size: 20px;
  margin-right: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.error-alert .alert-icon {
  background-color: #ffebee;
  color: #d32f2f;
}

.success-alert .alert-icon {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.alert-content {
  flex: 1 1;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #0066cc;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.activity-form-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

.form-group {
  margin-bottom: 25px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);
  outline: none;
}

select.form-control {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 16px;
  padding-right: 40px;
}

textarea.form-control {
  min-height: 150px;
  resize: vertical;
}

.form-hint {
  margin-top: 6px;
  font-size: 14px;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.submit-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.submit-button:hover {
  background-color: #004499;
}

.submit-button:disabled {
  background-color: #99ccff;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 20px;
  border-top: 1px solid #eee;
  gap: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.notification-message {
  width: 100%;
  min-height: 120px;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

.cancel-button {
  padding: 8px 16px;
  background-color: #f1f1f1;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.send-notification-button {
  background-color: #4CAF50;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.send-notification-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.actions-toolbar {
  margin: 15px 0;
  display: flex;
  gap: 10px;
}

.success-message {
  color: green;
  margin-top: 10px;
}

.error-message {
  color: red;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,WAAW;;AAEb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;AACA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yDAAmR;EACnR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,wIAAwI;AAC1I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yDAAmR;EACnR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;AACA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* src/App.css */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: #333;\n  background-color: #f5f7fa;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Navbar styles */\n.navbar {\n  background-color: #2c3e50;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n}\n\n.navbar a {\n  color: white;\n  text-decoration: none;\n  margin-left: 20px;\n}\n\n.navbar-brand a {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-left: 0;\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 1rem;\n  margin-left: 20px;\n}\n\n/* Form styles */\n.login-container,\n.register-container {\n  max-width: 500px;\n  margin: 40px auto;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\nh1 {\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n\ninput {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\nbutton {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  margin: 3px;\n}\n\nbutton:hover {\n  background-color: #2980b9;\n}\n\n.error {\n  color: #e74c3c;\n  margin-bottom: 15px;\n  padding: 10px;\n  background-color: #ffeaea;\n  border-radius: 4px;\n}\n\n/* Dashboard styles */\n.dashboard-container {\n  padding: 20px;\n}\n\n.activities-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.activity-card {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.activity-card.completed {\n  border-left: 5px solid #27ae60;\n}\n\n.activity-card h3 {\n  margin-bottom: 10px;\n  color: #2c3e50;\n}\n\n.activity-content {\n  margin: 10px 0;\n  color: #666;\n}\n\n.complete-button {\n  background-color: #27ae60;\n  margin-top: 15px;\n}\n\n.complete-button:hover {\n  background-color: #219653;\n}\n\n.completed-badge {\n  display: inline-block;\n  background-color: #27ae60;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 4px;\n  margin-top: 15px;\n  font-size: 14px;\n}\n.dashboard-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.activities-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.activities-table th,\n.activities-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.activities-table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n\n.activities-table tr:hover {\n  background-color: #f9f9f9;\n}\n\n.activity-name {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.activity-type {\n  color: #7f8c8d;\n}\n\n.activity-content {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.view-button {\n  display: inline-block;\n  padding: 8px 12px;\n  background-color: #3498db;\n  color: white;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  margin: 2px;\n\n}\n\n.view-button:hover {\n  background-color: #2980b9;\n}\n\n.no-activities {\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.user-management-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.search-container {\n  margin-bottom: 20px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s;\n}\n\n.search-input:focus {\n  border-color: #4a90e2;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 12px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border-left: 4px solid #c62828;\n}\n\n.loading-indicator {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n  font-size: 16px;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.users-table th {\n  background-color: #f5f7fa;\n  color: #333;\n  font-weight: 600;\n  text-align: left;\n  padding: 14px 16px;\n  border-bottom: 2px solid #e3e8ee;\n}\n\n.users-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e3e8ee;\n  text-align: center;\n}\n\n.user-row:hover {\n  background-color: #f9fafc;\n}\n\n.user-name {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.user-email {\n  color: #3498db;\n}\n\n.user-actions {\n  white-space: nowrap;\n}\n\n.view-measurements-button {\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s;\n}\n\n.view-measurements-button:hover {\n  background-color: #3a7bc8;\n}\n\n.no-results-row td {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n}\n\n.user-count {\n  text-align: right;\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.actions-container {\n  margin-top: 20px;\n}\n\n.back-button {\n  background-color: #f5f7fa;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 10px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.back-button:hover {\n  background-color: #e9ecef;\n}\n/* src/pages/QuestionnaireList.css */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.subtitle {\n  color: #6c757d;\n  margin-top: 5px;\n}\n\n.create-button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 4px;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.create-button:hover {\n  background-color: #0069d9;\n}\n\n.search-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  align-items: center;\n}\n\n.search-box {\n  flex: 1;\n  max-width: 400px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n}\n\n.results-count {\n  color: #6c757d;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.loading-container {\n  text-align: center;\n  padding: 40px 0;\n}\n\n.loading-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 2s linear infinite;\n  margin: 0 auto 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 0;\n}\n\n.questionnaires-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.questionnaires-table th,\n.questionnaires-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.questionnaires-table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n}\n\n.questionnaires-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.title-cell {\n  font-weight: bold;\n}\n\n.no-description {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.badge {\n  background-color: #17a2b8;\n  color: white;\n  padding: 5px 8px;\n  border-radius: 4px;\n  font-size: 0.85em;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 5px;\n}\n\n.view-button,\n.edit-button,\n.delete-button {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.view-button {\n  background-color: #6c757d;\n  color: white;\n}\n\n.edit-button {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.delete-button {\n  background-color: #dc3545;\n  color: white;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.pagination-button {\n  padding: 8px 12px;\n  margin: 0 5px;\n  border: 1px solid #dee2e6;\n  background-color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.pagination-button.active {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: white;\n  border-radius: 5px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 20px;\n  border-top: 1px solid #dee2e6;\n  gap: 10px;\n}\n\n.cancel-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .create-button {\n    margin-top: 10px;\n  }\n  \n  .search-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .search-box {\n    max-width: 100%;\n    margin-bottom: 10px;\n  }\n  \n  .questionnaires-table {\n    display: block;\n    overflow-x: auto;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n  }\n}\n/* EditQuestionnaire.css */\n.questionnaire-editor {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.editor-header {\n  margin-bottom: 30px;\n}\n\n.editor-header h1 {\n  margin: 15px 0;\n  color: #333;\n  font-weight: 600;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #0066cc;\n  font-size: 16px;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n.error-message, .success-message {\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n.error-message {\n  background-color: #fff3f3;\n  color: #d32f2f;\n  border-left: 4px solid #d32f2f;\n}\n\n.validation-errors ul {\n  margin-top: 10px;\n  margin-bottom: 0;\n  padding-left: 20px;\n}\n\n.validation-errors li {\n  margin-bottom: 5px;\n}\n\n.success-message {\n  background-color: #f0fff0;\n  color: #2e7d32;\n  border-left: 4px solid #2e7d32;\n  display: flex;\n  align-items: center;\n}\n\n.success-icon {\n  font-size: 20px;\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #0066cc;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.editor-section {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n\n.section-header {\n  background-color: #f7f9fc;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e1e4e8;\n}\n\n.section-header h2 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n  font-weight: 600;\n}\n\n.questions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.section-content {\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\ninput[type=\"text\"]:focus,\ntextarea:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);\n  outline: none;\n}\n\n.input-error {\n  border-color: #d32f2f !important;\n}\n\n.error-text {\n  color: #d32f2f;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.add-button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-button:hover {\n  background-color: #004499;\n}\n\n.empty-questions {\n  text-align: center;\n  padding: 40px 0;\n  color: #666;\n}\n\n.empty-icon {\n  font-size: 48px;\n  color: #ccc;\n  margin-bottom: 15px;\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  line-height: 80px;\n  border-radius: 50%;\n  background-color: #f5f5f5;\n}\n\n.questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.question-card {\n  border: 1px solid #e1e4e8;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.question-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.question-card.active {\n  border-color: #0066cc;\n  box-shadow: 0 2px 12px rgba(0, 102, 204, 0.2);\n}\n\n.question-header {\n  padding: 15px;\n  background-color: #f7f9fc;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.question-card.active .question-header {\n  background-color: #e6f0ff;\n}\n\n.question-header:hover {\n  background-color: #e6f0ff;\n}\n\n.question-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.question-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background-color: #0066cc;\n  color: white;\n  border-radius: 50%;\n  font-weight: bold;\n}\n\n.question-title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n\n.question-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.options-count {\n  font-size: 14px;\n  color: #666;\n}\n\n.expand-icon {\n  color: #0066cc;\n  font-size: 12px;\n}\n\n.question-body {\n  padding: 20px;\n  border-top: 1px solid #e1e4e8;\n}\n\n.options-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.add-option-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-option-button:hover {\n  background-color: #e0e0e0;\n}\n\n.options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.option-item {\n  border: 1px solid #e1e4e8;\n  border-radius: 4px;\n  padding: 10px;\n  transition: border-color 0.2s;\n}\n\n.option-item:hover {\n  border-color: #0066cc;\n}\n\n.option-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.radio-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.radio-label {\n  font-size: 12px;\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n.option-input-container {\n  flex: 1;\n  display: flex;\n  gap: 10px;\n}\n\n.remove-option-button {\n  background: none;\n  border: none;\n  color: #d32f2f;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 5px;\n  transition: color 0.2s;\n}\n\n.remove-option-button:hover {\n  color: #b71c1c;\n}\n\n.remove-option-button:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.option-error {\n  margin-left: 30px;\n}\n\n.question-footer {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.remove-question-button {\n  background: none;\n  border: 1px solid #d32f2f;\n  color: #d32f2f;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.remove-question-button:hover {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 30px;\n}\n\n.cancel-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.save-button {\n  background-color: #2e7d32;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.save-button:hover {\n  background-color: #1b5e20;\n}\n\n.save-button:disabled {\n  background-color: #a5d6a7;\n  cursor: not-allowed;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s linear infinite;\n}\n\n@media (max-width: 768px) {\n  .question-title h3 {\n    max-width: 200px;\n  }\n  \n  .option-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .radio-container {\n    margin-bottom: 10px;\n  }\n  \n  .form-actions {\n    flex-direction: column-reverse;\n    gap: 10px;\n  }\n  \n  .cancel-button, .save-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* src/pages/admin/CreateQuestionnaire.css */\n.questionnaire-creator {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.creator-header {\n  margin-bottom: 30px;\n}\n\n.creator-header h1 {\n  margin: 15px 0;\n  color: #333;\n  font-weight: 600;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #0066cc;\n  font-size: 16px;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n.error-message, .success-message {\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n.error-message {\n  background-color: #fff3f3;\n  color: #d32f2f;\n  border-left: 4px solid #d32f2f;\n}\n\n.success-message {\n  background-color: #f0fff0;\n  color: #2e7d32;\n  border-left: 4px solid #2e7d32;\n  display: flex;\n  align-items: center;\n}\n\n.success-icon {\n  font-size: 20px;\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.creator-section {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n\n.section-header {\n  background-color: #f7f9fc;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e1e4e8;\n}\n\n.section-header h2 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n  font-weight: 600;\n}\n\n.questions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.section-content {\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\ninput[type=\"text\"]:focus,\ntextarea:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);\n  outline: none;\n}\n\n.add-button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-button:hover {\n  background-color: #004499;\n}\n\n.empty-questions {\n  text-align: center;\n  padding: 40px 0;\n  color: #666;\n}\n\n.empty-icon {\n  font-size: 48px;\n  color: #ccc;\n  margin-bottom: 15px;\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  line-height: 80px;\n  border-radius: 50%;\n  background-color: #f5f5f5;\n}\n\n.questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.question-card {\n  border: 1px solid #e1e4e8;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.question-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.question-card.active {\n  border-color: #0066cc;\n  box-shadow: 0 2px 12px rgba(0, 102, 204, 0.2);\n}\n\n.question-header {\n  padding: 15px;\n  background-color: #f7f9fc;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.question-card.active .question-header {\n  background-color: #e6f0ff;\n}\n\n.question-header:hover {\n  background-color: #e6f0ff;\n}\n\n.question-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.question-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background-color: #0066cc;\n  color: white;\n  border-radius: 50%;\n  font-weight: bold;\n}\n\n.question-title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n\n.question-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.options-count {\n  font-size: 14px;\n  color: #666;\n}\n\n.expand-icon {\n  color: #0066cc;\n  font-size: 12px;\n}\n\n.question-body {\n  padding: 20px;\n  border-top: 1px solid #e1e4e8;\n}\n\n.options-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.add-option-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-option-button:hover {\n  background-color: #e0e0e0;\n}\n\n.options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.option-item {\n  border: 1px solid #e1e4e8;\n  border-radius: 4px;\n  padding: 10px;\n  transition: border-color 0.2s;\n}\n\n.option-item:hover {\n  border-color: #0066cc;\n}\n\n.option-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.radio-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.radio-label {\n  font-size: 12px;\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n.option-input-container {\n  flex: 1;\n  display: flex;\n  gap: 10px;\n}\n\n.remove-option-button {\n  background: none;\n  border: none;\n  color: #d32f2f;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 5px;\n  transition: color 0.2s;\n}\n\n.remove-option-button:hover {\n  color: #b71c1c;\n}\n\n.remove-option-button:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.question-footer {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.remove-question-button {\n  background: none;\n  border: 1px solid #d32f2f;\n  color: #d32f2f;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.remove-question-button:hover {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.remove-question-button:disabled {\n  border-color: #e0e0e0;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 30px;\n}\n\n.cancel-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.create-button {\n  background-color: #2e7d32;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.create-button:hover {\n  background-color: #1b5e20;\n}\n\n.create-button:disabled {\n  background-color: #a5d6a7;\n  cursor: not-allowed;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@media (max-width: 768px) {\n  .question-title h3 {\n    max-width: 200px;\n  }\n  \n  .option-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .radio-container {\n    margin-bottom: 10px;\n  }\n  \n  .form-actions {\n    flex-direction: column-reverse;\n    gap: 10px;\n  }\n  \n  .cancel-button, .create-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n/* src/pages/Dashboard.css */\n.dashboard-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Header Styles */\n.dashboard-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.dashboard-header h1 {\n  margin: 0;\n  color: #333;\n  font-size: 28px;\n}\n\n.admin-badge {\n  background-color: #4caf50;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  margin-left: 15px;\n  font-weight: 500;\n}\n\n/* Navigation Section */\n.dashboard-navigation {\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.nav-section h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 20px;\n}\n\n.nav-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.nav-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n  text-align: center;\n}\n\n.nav-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.nav-icon {\n  font-size: 32px;\n  margin-bottom: 15px;\n}\n\n.nav-card h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.nav-card p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Activities Section */\n.activities-section {\n  background-color: white;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.view-all-link {\n  color: #0066cc;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.view-all-link:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #0066cc;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-message {\n  background-color: #fff3f3;\n  color: #d32f2f;\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border-left: 4px solid #d32f2f;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 0;\n  color: #666;\n}\n\n.empty-icon {\n  font-size: 48px;\n  color: #ccc;\n  margin-bottom: 15px;\n}\n\n.empty-state h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n}\n\n.empty-state p {\n  margin: 0;\n  color: #666;\n}\n\n.activities-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.activity-card {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  position: relative;\n  transition: transform 0.2s;\n  border-left: 4px solid #0066cc;\n}\n\n.activity-card:hover {\n  transform: translateY(-3px);\n}\n\n.activity-card.completed {\n  border-left-color: #4caf50;\n  background-color: #f1f8e9;\n}\n\n.activity-status {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.status-badge {\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.status-badge.pending {\n  background-color: #fff8e1;\n  color: #f57f17;\n}\n\n.status-badge.completed {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.activity-card h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 18px;\n  padding-right: 70px; /* Make room for the status badge */\n}\n\n.activity-card p {\n  margin: 0 0 20px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.activity-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.complete-button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.complete-button:hover {\n  background-color: #004499;\n}\n\n/* Admin Stats Section */\n.admin-stats-section {\n  margin-top: 30px;\n}\n\n.admin-stats-section h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 20px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.stat-card {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n  font-size: 32px;\n  margin-right: 20px;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.users-icon {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.activities-icon {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.questionnaires-icon {\n  background-color: #fff8e1;\n  color: #f57f17;\n}\n\n.health-icon {\n  background-color: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-content h3 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  color: #666;\n}\n\n.stat-link {\n  color: #0066cc;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.stat-link:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .nav-cards, .activities-grid, .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .admin-badge {\n    margin-left: 0;\n    margin-top: 10px;\n  }\n}\n/* src/pages/CreateActivity.css */\n.create-activity-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.create-activity-header {\n  margin-bottom: 30px;\n}\n\n.create-activity-header h1 {\n  margin: 15px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #0066cc;\n  font-size: 16px;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n.alert {\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.error-alert {\n  background-color: #fff3f3;\n  color: #d32f2f;\n  border-left: 4px solid #d32f2f;\n}\n\n.success-alert {\n  background-color: #f0fff0;\n  color: #2e7d32;\n  border-left: 4px solid #2e7d32;\n}\n\n.alert-icon {\n  font-size: 20px;\n  margin-right: 15px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.error-alert .alert-icon {\n  background-color: #ffebee;\n  color: #d32f2f;\n}\n\n.success-alert .alert-icon {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.alert-content {\n  flex: 1;\n}\n\n.activity-form-card {\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);\n  padding: 30px;\n}\n\n.form-group {\n  margin-bottom: 25px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-control {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-control:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);\n  outline: none;\n}\n\nselect.form-control {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 15px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\ntextarea.form-control {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.form-hint {\n  margin-top: 6px;\n  font-size: 14px;\n  color: #666;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.cancel-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.submit-button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.submit-button:hover {\n  background-color: #004499;\n}\n\n.submit-button:disabled {\n  background-color: #99ccff;\n  cursor: not-allowed;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .activity-form-card {\n    padding: 20px;\n  }\n  \n  .form-actions {\n    flex-direction: column-reverse;\n  }\n  \n  .cancel-button, .submit-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* src/pages/ActivityForm.css */\n.activity-form-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.activity-form-header {\n  margin-bottom: 30px;\n}\n\n.activity-form-header h1 {\n  margin: 15px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #0066cc;\n  font-size: 16px;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #004499;\n  text-decoration: underline;\n}\n\n.alert {\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.error-alert {\n  background-color: #fff3f3;\n  color: #d32f2f;\n  border-left: 4px solid #d32f2f;\n}\n\n.success-alert {\n  background-color: #f0fff0;\n  color: #2e7d32;\n  border-left: 4px solid #2e7d32;\n}\n\n.alert-icon {\n  font-size: 20px;\n  margin-right: 15px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.error-alert .alert-icon {\n  background-color: #ffebee;\n  color: #d32f2f;\n}\n\n.success-alert .alert-icon {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.alert-content {\n  flex: 1;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #0066cc;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container p {\n  color: #666;\n  font-size: 16px;\n  margin: 0;\n}\n\n.activity-form-card {\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);\n  padding: 30px;\n}\n\n.form-group {\n  margin-bottom: 25px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-control {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-control:focus {\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.2);\n  outline: none;\n}\n\nselect.form-control {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 15px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\ntextarea.form-control {\n  min-height: 150px;\n  resize: vertical;\n}\n\n.form-hint {\n  margin-top: 6px;\n  font-size: 14px;\n  color: #666;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.cancel-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #e0e0e0;\n}\n\n.submit-button {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.submit-button:hover {\n  background-color: #004499;\n}\n\n.submit-button:disabled {\n  background-color: #99ccff;\n  cursor: not-allowed;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s linear infinite;\n}\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 20px;\n  border-top: 1px solid #eee;\n  gap: 10px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n}\n\n.notification-message {\n  width: 100%;\n  min-height: 120px;\n  margin: 10px 0;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  resize: vertical;\n}\n\n.cancel-button {\n  padding: 8px 16px;\n  background-color: #f1f1f1;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.send-notification-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.send-notification-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.actions-toolbar {\n  margin: 15px 0;\n  display: flex;\n  gap: 10px;\n}\n\n.success-message {\n  color: green;\n  margin-top: 10px;\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
